import React from 'react'
import LightGrayBgWrapper from '../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper'
import styles from "./Dashboard.module.scss"
import DynamicCardRow from '../../../components/AdminPortalComponents/DynamicCardRow/DynamicCardRow'
import { Col, Container, Row } from 'reactstrap';
import ReceivedIcon from "../../../assets/icons/Admin/received.svg"
import ConfirmedIcon from "../../../assets/icons/Admin/confirmed.svg"
import ShippedIcon from "../../../assets/icons/Admin/shipped.svg"
import OutForDeliveryIcon from "../../../assets/icons/Admin/outfor.svg"
import DeliveredIcon from "../../../assets/icons/Admin/delivered.svg"
import CancelledIcon from "../../../assets/icons/Admin/cancelled.svg"
import ReturnedIcon from "../../../assets/icons/Admin/return.svg"
import FailedIcon from "../../../assets/icons/Admin/failed.svg"
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import TotalRevenueChart from '../../../components/AdminPortalComponents/Dashboard/TotalRevenueChart';
import YellowDot from "../../../assets/icons/Admin/yellowDot.svg"
import BlueDot from "../../../assets/icons/Admin/blueDot.svg"
import DesktopDot from "../../../assets/icons/Admin/desktopDot.svg"
import TabDot from "../../../assets/icons/Admin/tabDot.svg"
import RedDot from "../../../assets/icons/Admin/redDot.svg"
import DonutChartComponent from '../../../components/AdminPortalComponents/Dashboard/SalesByDeviceChart';
import StatCard from '../../../components/AdminPortalComponents/Dashboard/StatsCard';
import RedLine from "../../../assets/icons/Admin/redLine.svg"
import GreenLine from "../../../assets/icons/Admin/greenLine.svg"
import orangeLine from "../../../assets/icons/Admin/orangeLine.svg"
import yellowLine from "../../../assets/icons/Admin/yellowLine.svg"
import CircularProgress from '../../../components/AdminPortalComponents/Dashboard/CircularProgress';
import ProgressBarTable from '../../../components/common/AdminCommonComponents/DynamicDatatable/ProgressBarTable/ProgressBarTables';
import targetIcon from "../../../assets/icons/Admin/targetSales.svg"
import realSalesIcon from "../../../assets/icons/Admin/realSales.svg"
import BarChart from '../../../components/common/AdminCommonComponents/Graphs/BarChart/BarChart';
import DynamicDatatable from '../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable';
import ProfitView from '../../../components/common/AdminCommonComponents/Buttons/ActionButton/ProfitView';

function Dashboard() {
    const dashboardCardsData = [
        { title: "Received", value: 0, icon: <img src={ReceivedIcon} /> },
        { title: "Confirmed", value: 0, icon: <img src={ConfirmedIcon} /> },
        { title: "Shipped", value: 0, icon: <img src={ShippedIcon} /> },
        { title: "Out for delivery", value: 0, icon: <img src={OutForDeliveryIcon} /> },
        { title: "Delivered", value: 0, icon: <img src={DeliveredIcon} /> },
        { title: "Cancelled", value: 0, icon: <img src={CancelledIcon} /> },
        { title: "Returned", value: 0, icon: <img src={ReturnedIcon} /> },
        { title: "Failed", value: 0, icon: <img src={FailedIcon} /> },
    ].map(item => ({
        ...item,
        title: item.title.toUpperCase()
    }));
    const trafficCardsData = [
        { title: "Store visits", value: 8950 },
        { title: "visitors", value: 1520 },
    ].map(item => ({
        ...item,
        title: item.title.toUpperCase()
    }));
    const totalRevenuedata = [
        { month: "Jan", sales: 5, profit: 10 },
        { month: "Feb", sales: 7, profit: 15 },
        { month: "Mar", sales: 12, profit: 13 },
        { month: "Apr", sales: 10, profit: 18 },
        { month: "May", sales: 15, profit: 25 },
        { month: "Jun", sales: 3, profit: 20 },
        { month: "Jul", sales: 8, profit: 12 },
        { month: "Aug", sales: 13, profit: 10 },
        { month: "Sep", sales: 17, profit: 14 },
        { month: "Oct", sales: 9, profit: 11 },
        { month: "Nov", sales: 10, profit: 5 },
        { month: "Dec", sales: 6, profit: 3 }
    ];
    const visitorInsightsdata = [
        { month: "Jan", loyal: 5, new: 10, unique: 12 },
        { month: "Feb", loyal: 7, new: 15, unique: 14 },
        { month: "Mar", loyal: 12, new: 13, unique: 16 },
        { month: "Apr", loyal: 10, new: 18, unique: 18 },
        { month: "May", loyal: 15, new: 25, unique: 1 },
        { month: "Jun", loyal: 3, new: 20, unique: 2 },
        { month: "Jul", loyal: 8, new: 12, unique: 3 },
        { month: "Aug", loyal: 13, new: 10, unique: 6 },
        { month: "Sep", loyal: 17, new: 14, unique: 8 },
        { month: "Oct", loyal: 9, new: 11, unique: 10 },
        { month: "Nov", loyal: 10, new: 5, unique: 20 },
        { month: "Dec", loyal: 6, new: 3, unique: 25 }
    ];

    const trafficChartdata = [
        { traffice: 5, },
        { traffice: 7, },
        { traffice: 12, },
        { traffice: 10, },
        { traffice: 15, },
    ];
    const data = [
        { label: "Desktop", value: 15, strokeWidth: 15 }, // Yellow (Increased Width)
        { label: "Mobile", value: 10 },
        { label: "Tablet", value: 10 },
        { label: "Unknown", value: 10 },
    ]
    const colors = [
        "#FF8901",
        "#FBBD34",
        "#2F80ED",
        "#FF392B"
    ]
    const dataSamples = {
        sales: [
            { value: 5 },
        ],
        profit: [
            { value: 3 },
        ],
        orders: [
            { value: 2 },
        ],
        visitors: [
            { value: 6 },
        ],
    };
    const barChartData = [
        {
            name: "Jan",
            targetsales: 12,
            realitysales: 14,
        },
        {
            name: "Feb",
            targetsales: 24,
            realitysales: 12,
        },
        {
            name: "Mar",
            targetsales: 24,
            realitysales: 12,
        },
        {
            name: "Apr",
            targetsales: 24,
            realitysales: 12,
        },
    ]
    const tableData = [
        {
            product: "Flowering Cactus",
            price: "$41.75",
            sold: 636,
            profit: "$9327",
        },
        {
            product: "Flowering Cactus",
            price: "$41.75",
            sold: 636,
            profit: "$9327",
        },
        {
            product: "Flowering Cactus",
            price: "$41.75",
            sold: 636,
            profit: "$9327",
        },
        {
            product: "Flowering Cactus",
            price: "$41.75",
            sold: 636,
            profit: "$9327",
        },
    ]

    const columns = [
        { name: 'Product', selector: (row) => row.product },
        { name: 'Price', selector: (row) => row.price },
        { name: 'Sold', selector: (row) => row.sold },
        { name: 'Profit', selector: (row) => <ProfitView profit={row.profit} /> },
    ]
    return (
        <LightGrayBgWrapper>
            <div className={styles.cardCont}>
                <h5 className={styles.mainHeading}>Orders</h5>
                <div className={styles.cardRowWrapper}>
                    <DynamicCardRow cards={dashboardCardsData} />
                </div>
            </div>
            <div className={styles.cardCont2}>
                <h5 className={styles.mainHeading}>Total Revenue</h5>
                <div className='d-flex gap-4 mt-4 mb-4'>
                    <div className={"d-flex gap-2"}>
                        <img src={YellowDot} />
                        <div>Sales</div>
                    </div>
                    <div className={"d-flex gap-2"}>
                        <img src={BlueDot} />
                        <div>Profit</div>
                    </div>
                </div>
                <TotalRevenueChart
                    height={300}
                    yaxis={true}
                    data={totalRevenuedata}
                    domain={[0, 30]}
                    ticks={[0, 5, 10, 15, 20, 25, 30]}
                    strokeWidth={2}
                    chartHeight={400}
                    dataKey={"month"}
                    strokes={[
                        {
                            color: "#f4a742",
                            dataKey: "profit"
                        },
                        {
                            color: "#3a9bfd",
                            dataKey: "sales"
                        },
                    ]}
                />
            </div>
            <Row>
                <Col className={styles.containers}>
                    <h4>Sales By Device</h4>
                    <div className='d-flex justify-content-center items-center'>
                        <DonutChartComponent data={data} colors={colors} />
                    </div>
                    <div className='d-flex justify-content-between'>
                        <div>
                            <div className='d-flex gap-2 mb-3'>
                                <img src={DesktopDot} />
                                <div className={styles.donutChartText}>Desktop</div>
                                <div className={styles.textbg}>$830.03</div>
                                <div className={styles.donutChartText}>63.2%</div>
                            </div>
                            <div className='d-flex gap-2'>
                                <img src={BlueDot} />
                                <div className={styles.donutChartText}>Mobile</div>
                                <div className={styles.textbg}>$775.75</div>
                                <div className={styles.donutChartText}>48.6%</div>
                            </div>
                        </div>
                        <div className={styles.border1}></div>
                        <div>
                            <div className='d-flex gap-2 mb-3'>
                                <img src={TabDot} />
                                <div className={styles.donutChartText}>Tablet</div>
                                <div className={styles.textbg}>$830.03</div>
                                <div className={styles.donutChartText}>63.2%</div>
                            </div>
                            <div className='d-flex gap-2'>
                                <img src={RedDot} />
                                <div className={styles.donutChartText}>Unknown</div>
                                <div className={styles.textbg}>$775.75</div>
                                <div className={styles.donutChartText}>48.6%</div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col className={styles.donutChart}>
                    <h4>Traffic</h4>
                    <div className="container mt-4">
                        <div className="row g-3">
                            <div className="col-md-8 col-lg-6">
                                <StatCard titleValue={"22%"} firstCard={true} title="Store Visitors" value="20000" color="#FF8F0D" data={dataSamples.sales} />
                            </div>
                            <div className="col-md-8 col-lg-6">
                                <StatCard titleValue={"-24%"} title="Visitors" value="1500" color="#FF3B3B" data={dataSamples.profit} />
                            </div>
                        </div>
                    </div>
                    <div className={styles.chartText}>Jan 16 - Jan 30 store visits chart</div>
                    <TotalRevenueChart
                        height={200}
                        data={trafficChartdata}
                        domain={false}
                        ticks={false}
                        strokeWidth={4}
                        chartWidth={500}
                        chartHeight={250}
                        // dataKey={"month"}
                        strokes={[
                            {
                                color: "#EC7426",
                                dataKey: "traffice"
                            },
                        ]}
                    />
                </Col>
            </Row>
            <Row>
                <Col className={styles.donutChart}>
                    <h4>Sales Overview</h4>
                    <div className="container mt-4">
                        <div className="row g-3">
                            <div className="col-md-8 col-lg-6">
                                <StatCard Line={orangeLine} title="Sales" value="20000" color="#FF8F0D" data={dataSamples.sales} />
                            </div>
                            <div className="col-md-8 col-lg-6">
                                <StatCard Line={RedLine} title="Net Profit" value="1500" color="#FF3B3B" data={dataSamples.profit} />
                            </div>
                        </div>
                    </div>
                    <div className="container mt-4">
                        <div className="row g-3">
                            <div className="col-md-8 col-lg-6">
                                <StatCard Line={GreenLine} title="Orders" value="20000" color="#FF8F0D" data={dataSamples.sales} />
                            </div>
                            <div className="col-md-8 col-lg-6">
                                <StatCard Line={yellowLine} title="Visitors" value="1500" color="#FF3B3B" data={dataSamples.profit} />
                            </div>
                        </div>
                    </div>
                </Col>
                <Col className={styles.donutChart}>
                    <h4>Abondoned Cart Review</h4>
                    <div className='d-flex gap-2'>
                        <CircularProgress percentage={80} />
                        <div className='d-flex gap-4 mt-5 '>
                            <div className='mt-5'>
                                <div className='mt-3'>Abandoned Cart</div>
                                <div className={`mt-3`}>Abandoned Value</div>
                            </div>
                            <div className='mt-5'>
                                <div className='mt-3'>720</div>
                                <div className={`mt-3 ${styles.donutChartText}`}>$5,900</div>
                            </div>
                        </div>

                    </div>
                </Col>
            </Row>
            <Row>
                <Col className={styles.donutChart}>
                    <h4>Sales Overview</h4>
                    <DynamicDatatable type={"gray"} data={tableData} columns={columns} />
                </Col>
                <Col className={styles.donutChart}>
                    <h4>Popular Stores</h4>
                    <ProgressBarTable />
                </Col>
            </Row>
            <Row>
                <Col className={styles.donutChart}>
                    <h4 className='mb-5'>Visitor Insights</h4>
                    <TotalRevenueChart
                        data={visitorInsightsdata}
                        height={300}
                        yaxis={true}
                        domain={[0, 30]}
                        ticks={[0, 5, 10, 15, 20, 25, 30]}
                        strokeWidth={3.5}
                        chartHeight={400}
                        dataKey={"month"}
                        strokes={[
                            {
                                color: "#FBBD34",
                                dataKey: "loyal"
                            },
                            {
                                color: "#41B8E4",
                                dataKey: "new"
                            },
                            {
                                color: "#FF3E1D",
                                dataKey: "unique"
                            },
                        ]}
                    />
                    <div className='d-flex gap-4 mt-4 justify-content-center'>
                        <div className='d-flex gap-1'>
                            <img src={YellowDot} />
                            <div>Loyal Customers</div>
                        </div>
                        <div className='d-flex gap-1'>
                            <img src={BlueDot} />
                            <div>New Customers</div>
                        </div>
                        <div className='d-flex gap-1'>
                            <img src={RedDot} />
                            <div>Unique Customers</div>
                        </div>
                    </div>
                </Col>
                <Col className={styles.donutChart}>
                    <h4 className=''>Sales Check</h4>
                    <div className='d-flex justify-content-end gap-4'>
                        <div className='d-flex gap-2'>
                            <img src={targetIcon} />
                            <div>
                                <div className='fw-bold'>Target Sales</div>
                                <div className='fw-bold'>14.00M</div>
                            </div>
                        </div>
                        <div className='d-flex gap-2'>
                            <img src={realSalesIcon} />
                            <div>
                                <div className='fw-bold'>Reality Sales</div>
                                <div className='fw-bold'>20.00M</div>
                            </div>
                        </div>
                    </div>
                    <BarChart
                        data={barChartData}
                        fillColor={"#41B8E4"}
                        secFillColor={"#FFCF00"}
                        dataKey1='targetsales'
                        dataKey2='realitysales'
                        yaxis={true}
                        domain={[0, 30]}
                        ticks={[0, 5, 10, 15, 20, 25, 30]}
                    />
                </Col>
            </Row>
        </LightGrayBgWrapper>
    )
}

export default Dashboard
